import React from 'react';
import {
  AGENT_STATUS_LABELS,
  AGENT_STATUS_TONES,
  B2C_STATUS_TONES,
  getCategoryLabel,
} from './supportConstants';

export function SupportStatusBadge({ status, variant = 'b2c', className = '' }) {
  if (variant === 'agent') {
    const label = AGENT_STATUS_LABELS[status] || status?.replace(/_/g, ' ') || '—';
    const tone = AGENT_STATUS_TONES[status] || 'bg-gray-100 text-gray-700';
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full ${tone} ${className}`}
        data-testid={`support-status-${status}`}
      >
        {label}
      </span>
    );
  }
  const tone = B2C_STATUS_TONES[status] || 'bg-gray-100 text-gray-700';
  return (
    <span className={`text-[10px] px-2 py-0.5 rounded-full ${tone} ${className}`}>
      {status?.replace(/_/g, ' ') || '—'}
    </span>
  );
}

export function SupportCategoryLabel({ category }) {
  return <>{getCategoryLabel(category)}</>;
}

export default SupportStatusBadge;
